
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Lighting Design & Installation',
      description: 'Custom lighting solutions that enhance your home\'s ambiance and functionality.',
      image: 'https://public.readdy.ai/ai/img_res/5610cb0a2604ca830ec8c150f370899d.jpg'
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Panel Upgrades',
      description: 'Electrical panel upgrades to meet modern power demands safely and efficiently.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrical%20panel%20upgrade%20installation%20in%20residential%20home%20showing%20modern%20circuit%20breaker%20panel%20with%20clean%20wiring%20and%20safety%20compliance&width=400&height=300&seq=service-2&orientation=landscape'
    },
    {
      icon: 'ri-home-wifi-line',
      title: 'Smart Home Integration',
      description: 'Transform your home with intelligent electrical systems and automation.',
      image: 'https://readdy.ai/api/search-image?query=Smart%20home%20electrical%20automation%20system%20with%20modern%20control%20panels%20and%20intelligent%20lighting%20in%20a%20contemporary%20residential%20setting%20showcasing%20advanced%20technology%20integration&width=400&height=300&seq=service-3&orientation=landscape'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Emergency Services',
      description: '24/7 emergency electrical repairs to keep your home safe and powered.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrician%20providing%20emergency%20electrical%20repair%20service%20in%20residential%20home%20with%20professional%20tools%20and%20safety%20equipment%20during%20urgent%20electrical%20work&width=400&height=300&seq=service-4&orientation=landscape'
    },
    {
      icon: 'ri-car-line',
      title: 'EV Charging Stations',
      description: 'Professional installation of electric vehicle charging solutions.',
      image: 'https://readdy.ai/api/search-image?query=Electric%20vehicle%20charging%20station%20installation%20in%20residential%20garage%20with%20professional%20electrical%20work%20and%20modern%20EV%20charger%20mounted%20on%20clean%20wall&width=400&height=300&seq=service-5&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safety Inspections',
      description: 'Comprehensive electrical safety inspections for peace of mind.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrical%20safety%20inspection%20being%20conducted%20in%20residential%20home%20with%20electrician%20using%20testing%20equipment%20and%20ensuring%20electrical%20system%20compliance&width=400&height=300&seq=service-6&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-800">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our <span className="text-yellow-400">Services</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            From simple repairs to complex installations, we provide comprehensive electrical services 
            tailored to your home's unique needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-900 rounded-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300 cursor-pointer">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent"></div>
                <div className="absolute top-4 left-4 w-12 h-12 bg-yellow-400 rounded-lg flex items-center justify-center">
                  <i className={`${service.icon} text-xl text-gray-900`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-white mb-3">{service.title}</h3>
                <p className="text-gray-300 mb-4">{service.description}</p>
                <Button variant="outline" size="sm">Learn More</Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button size="lg">
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-phone-line"></i>
            </div>
            Contact Us Today
          </Button>
        </div>
      </div>
    </section>
  );
}
